module.exports = __webpack_public_path__ + "img/Ridder iQ Logo.9205db45.svg";